import React from "react";
import PropTypes from "prop-types";

const FormField = ({
  input: { name, value, onChange, ...inputRest },
  meta: { touched, error, ...metaRest },
  label,
  fieldName,
  handleInput,
  classes,
  placeholderText,
  isRequired,
  ...props
}) => (
  <div
    className={`${touched && error ? `has-feeback has-error ${classes}` : `${classes}`}`}>
    <label htmlFor={name} className={isRequired ? "required-field" : ""}>
      {label}
    </label>
    <input
      name={`event_register_form[${name}]`}
      id={`event_register_form_${name}`}
      type="text"
      placeholder={placeholderText}
      value={value || ""}
      onChange={(e) => {
        onChange(e);
        handleInput(fieldName, e);
      }}
      {...inputRest}
    />
    {touched && error && <span className="donation-error">{error}</span>}
  </div>
);

FormField.propTypes = {};

export default FormField;
